import { defineStore, storeToRefs } from 'pinia';
import { localMemory } from 'localmemory';
import { useRouter } from 'vue-router';
import useAuthStore from './authStore';
import { ISrc } from '@/service/useUpload';

export interface IUserInfo {
  account: string;
  userID: string;
  username: string;
  email: string;
  nickname: string;
  phoneNumber: string;
  areaCode: string;
  faceUrl: ISrc | string;
  role: {
    id: string;
    name: string;
    describe: string;
  };
  sign: string;
  group: string;
  status: string;
  mangerLevel: string;
  seat: string;
  createTime: string;
}

const useUserStore = defineStore('userStore', () => {
  const authStore = useAuthStore();
  const router = useRouter();

  // 登录凭证
  const userToken = ref('');

  // 用户信息
  const userInfo = ref<IUserInfo>({
    account: '',
    userID: '',
    username: '',
    email: '',
    nickname: '',
    phoneNumber: '',
    areaCode: '',
    faceUrl: null,
    role: {
      id: '',
      name: '',
      describe: '',
    },
    sign: '',
    group: '',
    status: null,
    mangerLevel: null,
    seat: null,
    createTime: null,
  });

  /**
   * 设置用户信息
   */
  const setUserInfo = (payload: { token: string; userInfo }) => {
    userToken.value = payload.token;
    userInfo.value = payload.userInfo;
    localMemory.setItem({ name: 'userToken', value: payload.token });
    localMemory.setItem({ name: 'userInfo', value: payload.userInfo });
  };

  /**
   * 退出
   */
  const logOut = () => {
    userInfo.value = null;

    userToken.value = '';
    localMemory.removeItem('userToken');
    localMemory.removeItem('userInfo');
    authStore.resetPermission();
    router.push({ name: 'login' });
  };

  return {
    userInfo,
    userToken,
    setUserInfo,
    logOut,
  };
});

export default useUserStore;
